
const BancoPortugalInfo = () => (


    <div className="rounded-md bg-[#eeece3] p-4 mb-10 md:mb-10 lg:block md:block sm:block xs:mb-4 xs:hidden hidden">
        <p className="flex items-center font-medium text-dark text-xs">
            AMCO Intermediários de Crédito, Lda. Intermediário de Crédito vinculado e autorizado pelo Banco de Portugal nº759.
        </p>
    </div>

);

export default BancoPortugalInfo;